import type { MessageCategory } from "@/api/mailApi";

export interface CategoryTheme {
    label: string;
    /** Background color class for the dot / pill. */
    dot: string;
    /** Muted background for the active-filter pill. */
    pillBg: string;
    /** Ring color for the active-filter pill. */
    pillRing: string;
    /** Solid pill (white text) — list rows and the reading-pane header. */
    solid: string;
}

export const categoryTheme: Record<MessageCategory, CategoryTheme> = {
    work:      { label: "Work",      dot: "bg-blue-500",    pillBg: "bg-blue-500/10",    pillRing: "ring-blue-500/40",    solid: "bg-blue-600 text-white" },
    personal:  { label: "Personal",  dot: "bg-emerald-500", pillBg: "bg-emerald-500/10", pillRing: "ring-emerald-500/40", solid: "bg-emerald-700 text-white" },
    travel:    { label: "Travel",    dot: "bg-amber-500",   pillBg: "bg-amber-500/10",   pillRing: "ring-amber-500/40",   solid: "bg-amber-700 text-white" },
    finance:   { label: "Finance",   dot: "bg-violet-500",  pillBg: "bg-violet-500/10",  pillRing: "ring-violet-500/40",  solid: "bg-violet-600 text-white" },
    urgent:    { label: "Urgent",    dot: "bg-red-500",     pillBg: "bg-red-500/10",     pillRing: "ring-red-500/40",     solid: "bg-red-600 text-white" },
    followup:  { label: "Follow up", dot: "bg-orange-500",  pillBg: "bg-orange-500/10",  pillRing: "ring-orange-500/40",  solid: "bg-orange-700 text-white" },
    meetings:  { label: "Meetings",  dot: "bg-teal-500",    pillBg: "bg-teal-500/10",    pillRing: "ring-teal-500/40",    solid: "bg-teal-700 text-white" },
    social:    { label: "Social",    dot: "bg-pink-500",    pillBg: "bg-pink-500/10",    pillRing: "ring-pink-500/40",    solid: "bg-pink-700 text-white" },
    reference: { label: "Reference", dot: "bg-slate-500",   pillBg: "bg-slate-500/10",   pillRing: "ring-slate-500/40",   solid: "bg-slate-600 text-white" },
    promotions:{ label: "Promotions",dot: "bg-lime-500",    pillBg: "bg-lime-500/10",    pillRing: "ring-lime-500/40",    solid: "bg-lime-800 text-white" },
    updates:   { label: "Updates",   dot: "bg-indigo-500",  pillBg: "bg-indigo-500/10",  pillRing: "ring-indigo-500/40",  solid: "bg-indigo-600 text-white" }
};

/**
 * Automated mail — newsletters, notifications, receipts, social. The inbox's
 * "Updates" tab holds these; everything else is "Direct" (Doc/MAIL_UI_REDESIGN.md).
 * Their own pill is redundant in the list, so rows don't show it.
 */
export const UPDATES_CATEGORIES: ReadonlySet<MessageCategory> = new Set<MessageCategory>(["updates", "promotions", "social"]);

export function isUpdate(category: MessageCategory | null | undefined): boolean {
    return category != null && UPDATES_CATEGORIES.has(category);
}
